export enum PurchaseOrderOptions {
  Hidden = 0,
  Optional = 1,
  Mandatory = 2,
}
